module.exports = __webpack_public_path__ + "img/Recurso 55@300x.feceedba.png";